const en = {
    error1: 'Server error, please try again.',
    error1_1: 'Internal server error, please try again later',
    error1_2: 'The server does not support this request. Please try again later',
    error1_3: 'The server is unavailable, please try again later',
    error1_4: 'Server gateway timeout, please try again later',
    error1_5: 'The server does not support the HTTP version, please try again later',
    error2: 'Request data needs to be passed in.',
    error3: 'Parameter error.',
    error4: 'Database not initialized.',
    error5: 'Enumeration type error.',
    error6: 'Parameter passing error.',
    error7: 'Token is missing or expired.',
    error8: 'preUpload.Id does not exist.',
    error9: 'fileInfo.Id does not exist.',
    error10: 'File index already exists.',
    error11: 'File missing part.',
    error12: 'Corresponding file not found.',
    error13: 'Admin permissions do not allow modification.',
    error14: 'Refresh token does not exist.',
    error15: 'Corresponding data not found.',
    error16: 'Mobile phone number not found.',
    error17: 'The mobile phone number already exists.',
    error18: 'Account or password error.',
    error19: 'Multiple employees do not exist.',
    error20: 'The organization is not found.',
    error21: 'The employee already exists in the organization.',
    error22: 'The organization is taking inventory.',
    error23: 'Logbook does not exist.',
    error24: 'Doc does not exist.',
    error25: 'Product category does not exist.',
    error26: 'Product does not exist.',
    error27: 'Scan does not exist.',
    error28: 'Multiple scans do not exist.',
    error29: 'The barcode already exists in the scan.',
    error30: 'The outbound/inbound order data is not found.',
    error31: 'Insufficient inventory.',
    error32: 'The inventory list is not found.',
    error33: 'The inventory item does not exist.',
    error34: 'The code already exists and cannot be added again!',
    error35: 'Network error, please check your network connection and try again.',
    error36: 'Request timed out, please try again.',
    error37: 'Duplicate product category codes.',
    error38: 'The scanning order contains no product data or barcode data, resulting in inability to enter/exit the warehouse. The page will be closed soon.',
    error39: 'Insufficient stock',
    error40: 'Over-issue application not found',
    error41: 'Application status does not allow this operation',
    error42: 'Requirement item is invalid or not matched',
    error43: 'Over-issue quantity must be greater than 0',
    error44: 'Over-issue item has already generated an outbound order',
    error45: 'Customer code already exists',
    error46: 'Shipping address not found',
    error47: 'Shipping address name already exists',
    error48: 'Equipment not found',
    error49: 'The current equipment status does not allow this operation',
    error50: 'The equipment is not in stock and cannot be borrowed',
    error51: 'The equipment is not in use and cannot be returned',
    error52: 'The equipment already has an unreturned borrowing record',
    error53: 'This record type must use its dedicated endpoint',
    error54: 'The equipment has already been scrapped',
    error55: 'Invalid equipment status transition',
    error56: 'Invalid maintenance configuration',
    error57: 'The equipment number already exists',
    error58: 'Equipment record not found',
    error59: 'The equipment category code already exists',
    error60: 'Equipment category not found',
    error61: 'The parent category is disabled, so the child category cannot be enabled',
    error62: 'The category has child categories and cannot be deleted',
    error63: 'The category is already in use; its code or name cannot be changed',
    error64: 'The keeper organization is required',
    error65: 'Equipment can only be linked to a leaf category',
    error66: "Operation is queued for execution, please try again later",
};

export default en;
